import React from 'react';
import { BlishkaChatbot } from '../BlishkaChatbot';
import { navigateTo } from '../../utils/router';

interface ChatPageProps {
  onOpenBookingModal: () => void;
  onNavigateToMenu: () => void;
}

export const ChatPage: React.FC<ChatPageProps> = ({
  onOpenBookingModal,
  onNavigateToMenu
}) => {
  return (
    <div className="chat-page-wrapper">
      <h1 className="sr-only">Blishka AI Beauty Assistant | Consultation &amp; Doorstep Booking</h1>
      <BlishkaChatbot
        isOpen={true}
        onClose={() => navigateTo('/')}
        onOpenBookingModal={onOpenBookingModal}
        onNavigateToMenu={onNavigateToMenu}
        isPageView={true}
      />
    </div>
  );
};
